module.exports = __webpack_public_path__ + "static/LOGO_D-ed58fd2446fd6adbddd1ce1af9437d1d.svg";